export default function AboutSection() {
  return (
    <section id="about" className="section-scroll py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-red-600 text-xs md:text-sm font-semibold tracking-widest uppercase mb-2">了解我们</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">关于我们</h2>
          <p className="mt-2 text-gray-500 text-sm md:text-base max-w-lg mx-auto">
            致力于打造最优质的91免费在线视频观影平台
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 md:gap-12 items-center">
            <div className="lg:col-span-2 flex justify-center">
              <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl bg-gradient-to-br from-red-600 to-red-800 flex items-center justify-center shadow-lg">
                <div className="text-center">
                  <i className="ri-movie-2-line text-white text-5xl md:text-6xl block mb-3"></i>
                  <span className="text-white font-bold text-lg md:text-xl">91年国产影片</span>
                </div>
              </div>
            </div>
            <div className="lg:col-span-3">
              <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                91年国产影片视频成立于2024年，是一个专注于国产影片资源聚合与在线播放的综合性91免费视频网站。平台致力于为广大影迷提供便捷、高清、免费的91精品视频在线播放服务，让每一位用户都能轻松享受91在线观看免费的优质体验。
              </p>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                我们汇聚了涵盖剧情、爱情、动作、悬疑、喜剧等多种类型的国产影片资源，涵盖91麻豆免费视频网站等多个内容渠道的精选内容。通过持续优化播放技术和用户体验，平台已实现91在线免费播放的高清流畅观影效果。
              </p>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                未来，91年国产影片视频将持续拓展91福利在线视频等特色内容板块，不断提升片源质量与更新频率，努力成为用户首选的91免费看视频平台。我们相信，好的国产影片值得被更多人看到 — 91年国产影片视频，让每一部好片都不被错过。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}